export default __webpack_public_path__ + "static/media/news1.4a7bd656.png";